// extracted by mini-css-extract-plugin
module.exports = {"main":"Policies_main__3iQIi","scrollable":"Policies_scrollable__JR0iq"};